import { NbJSThemeOptions, DEFAULT_THEME as baseTheme } from '@nebular/theme';

export const GREEN_THEME = {
  name: 'green',
  base: 'default',
  variables: {
    // Solo cambiar los colores principales
    primary: '#28a745',
    success: '#20c997',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#17a2b8',
  },
}; 